<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M3.23,787.96l-1.82,1.82v11.82L0.5,802.5l-0.91-0.91v-11.82l-1.82-1.82l2.73-5.46L3.23,787.96z M10.12,793.13l-2.33,1.09
	l-2.49,6.83l-1.17,0.55l-0.54-1.17l2.49-6.83L5,791.26l4.43-4.19L10.12,793.13z M-3.99,791.26l-1.09,2.33l2.49,6.83l-0.55,1.17
	l-1.17-0.55l-2.49-6.83l-2.33-1.09l0.7-6.06L-3.99,791.26z"/>
</svg>

</template>